import { FileUploader, Link, Text } from '@lego/klik-ui';
import { ArrowUp, CloudArrowUpArrowDown } from '@lego/klik-ui/icons';
import type { ChangeEvent, DragEvent } from 'react';

type UploadDropZoneProps = {
  isInDropArea: boolean;
  onDragEnter: () => void;
  onDragLeave: () => void;
  onDragOver: (e: DragEvent<HTMLDivElement>) => void;
  onDrop: (e: DragEvent<HTMLDivElement>) => void;
  onFileSelect: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const UploadDropZone = ({
  isInDropArea,
  onDragEnter,
  onDragLeave,
  onDragOver,
  onDrop,
  onFileSelect,
}: UploadDropZoneProps) => {
  return (
    <FileUploader
      isInDropArea={isInDropArea}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDragOver={onDragOver}
      onDrop={onDrop}
    >
      <input accept="*/*" multiple={true} onChange={onFileSelect} type="file" />
      {isInDropArea ? (
        <>
          <ArrowUp />
          <Text fontSize="md">Drop to upload</Text>
        </>
      ) : (
        <>
          <CloudArrowUpArrowDown />
          <Text fontSize="md">Drag and drop a file</Text>
          <Text fontSize="xs">
            or{' '}
            <Link isInline size="xs">
              browse
            </Link>{' '}
            to choose a file
          </Text>
        </>
      )}
    </FileUploader>
  );
};
